import React from "react";
import PlIcon from "../pl_icon";
import {p0, p1, p2, p4, p8, p16, p32} from "../../pl_commons";
import {baseline, bm_left, bm_right} from "./icon_commons";

const BkIcon = ({item, handleArrowClick}) => {

    var svgitems = [];

    var resb;

    const w = 1

    let inroute = item.lockdir === "east" || item.lockdir === "west"

    var rtcolor = '#777777';
    if (inroute) {
        rtcolor = '#fff44f';
    } else if (item.inmemory === "true") {
        rtcolor = '#74bbff';
    }

    const lock = (item.lockid && item.lockid !== "");
    if (lock) {
        //rtcolor = 'rgba(72,115,185,0.59)';
    }

    let bmstate = item.fbstat === "true"
    if (bmstate) {
        rtcolor = '#ff0000';
    }


    let pxx = p1 * 2 - (p8 + 2);
    if (item.enterside === 'west') {
        pxx = p8 + 2;
    }

    var bkbg = '#c9c9c9';
    var bkfw = 'normal';
    var bkfs = 'normal';
    if (item.state === "reserved") {
        bkbg = 'var(--inlinefill)';
        bkfs = 'italic'
        resb = <circle cx={pxx} cy={p4 + p16 + 2} r={p16} fill={'#e7ca1c'}/>
    } else if (item.state === "enter") {
        bkbg = 'var(--inlinefill)';//bkbg = '#CBC8CC'; //'rgba(104,123,101,0.33)';
        bkfs = 'italic'
        resb = <circle cx={pxx} cy={p4 + p16 + 2} r={p16} fill={'#982727'}/>
    } else if (item.state === "occupied") {
        bkfw = 'bold';
        bkbg = 'var(--inlinefill)'; //'rgba(255,131,33,0.58)';
        resb = <circle cx={pxx} cy={p4 + p16 + 2} r={p16} fill={'#85a928'}/>
    }


    if (item.state === "free") {
        //item.lcstack = [];
    }

    let textbox = []
    if (item.lcid && item.lcid !== '' && item.lcid !== '0') {

        const rad = 0;

        textbox.push(<rect key="r0kk" x={p16} y={p4} width={(p1 * w) - p8} height={p4 * 2} rx={rad} ry={rad}
                           stroke='#444444' strokeWidth={1} fill={bkbg}/>);
        textbox.push(<text key="r1kk" x={p4} y={p2 + p16}
                           fill='#333333' fontFamily="monospace" fontSize={8} fontWeight={bkfw} fontStyle={bkfs}>
            {item.lcid === '0' || item.lcid === '' ? '' : item.lcid}
        </text>);

        item.lockdir === "west" ?
            textbox.push(<circle key={'cdir'} cx={p8} cy={p4 + p16} r={p32}/>) :
            textbox.push(<circle key={'cdir'} cx={p1 - p8} cy={p4 + p16} r={p32}/>)

    } else {
        svgitems.push(baseline());
        svgitems.push(bm_left({stroke: rtcolor}));
        svgitems.push(bm_right({stroke: rtcolor}));
    }

    if (item.subtype === "streckenblock") {
        svgitems = []

        svgitems.push(<circle key="c3"
                              cx={p2}
                              cy={p2}
                              r={p8}
                              fill={(lock) ? '#2b5ebe' : '#3b983b'}/>);

    }
    return (
        <PlIcon transform={undefined}>
            {svgitems}
            {textbox}
        </PlIcon>
    )
}

export default BkIcon